import React, { Fragment, useCallback, useEffect, useState } from "react";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import DefaultButton from "../../../components/buttons/defaultButton";
import { GiBackwardTime } from "react-icons/gi";
import toast from "react-hot-toast";
import { _fetchAuditLogs } from "../../../../store/actions/global";
import { useSelector } from "react-redux";
import DefaultBadge from "../../../components/badge/defaultBadge";
import moment from "moment";
import { ProfileView } from "../../../components/avatar/defaultAvatar";
import { getLogsList } from "../../../../services/workspace/global.service";
import { _categorizeByDate } from "../../../../utils/common";
import ListSkeleton from "../../../components/skeleton/listSheleton";

const breadcrumbs = [
  { label: "Audit Logs", path: "" },
];

const AuditLog = () => {
  const { limit } = useSelector((state) => state.global);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [fetchMore, setfetchMore] = useState(false)

  const fetchData = useCallback(() => {
    if (currentPage == 0 || !fetchMore) {
      setLoading(true);
    }
    getLogsList({ search: "", page: currentPage, limit })
      .then((response) => {
        setTableData(prevTableData => {
          const combinedData = currentPage === 1 ? [...response.data] : [...prevTableData, ...response.data];
          return combinedData;
        });
        setTotalData(response.total);
      })
      .catch((error) => {
        toast.error("Failed to fetch logs data!");
        console.error("Error fetching data: ", error);
      }).finally(() => {
        setLoading(false);
        setfetchMore(false)
      })
  }, [currentPage, limit]);

  useEffect(() => {
    fetchData()
  }, [fetchData]);;

  const fetchMoreData = () => {
    if (totalData == tableData?.length) return
    setfetchMore(true);
    setCurrentPage((prev) => prev + 1)
  }

  return (
    <div className="flex flex-col gap-2 p-4">
      <PageTableHeader
        breadcrumbs={breadcrumbs}
        isSearch={false}
        isFilter={false}
        buttons={false}
      />
      <div className="flex flex-col gap-4 p-4 bg-white">
        {loading ?
         <ListSkeleton/>
          :
          tableData && tableData.length ?
            <Fragment>
              {_categorizeByDate(tableData).map((item) => {
                return (
                  <div className="flex flex-col gap-1">
                    <p className="text-textLight">{item.category || "-"}</p>
                    <div className="flex flex-col gap-2">
                      {item.data.map((alert, index) => (
                        <AlertCard key={index} {...alert} />
                      ))}
                    </div>
                  </div>
                )
              })}
              {totalData === tableData.length ? null :
                <div className="flexCenter">
                  <DefaultButton
                    loading={fetchMore}
                    disabled={fetchMore || totalData === tableData.length}
                    onClick={fetchMoreData}
                    name={"Load More"}
                  />
                </div>}
            </Fragment> :
            <div>
              No Data Found!
            </div>
        }
      </div>
    </div>
  );
};

const AlertCard = ({
  profilePic,
  message,
  created_at,
  event,
  thumb,
  ip,
  request_from
}) => (
  <div className="flex justify-between items-center bg-light hover:bg-white border-white border hover:border-borderColor hover:border cursor-pointer p-4 rounded-lg ">
    <div className="flex gap-2 items-center">
      <div className="w-10 h-10 rounded-full bg-bghoverlight relative flexCenter">
        {thumb ? (
          <img
            src={profilePic}
            alt="Profile"
            className="w-10 h-10 rounded-full object-cover"
          />
        ) : (
          <GiBackwardTime className="text-xl text-theme" />
        )}
      </div>
      <div>
        <h3 className="font-semibold text-theme">{message}</h3>
        <p className="text-textLight">
          {moment(created_at).format("DD-MM-YYYY")} | {moment(created_at).format("HH:MM:a")}
        </p>
        {request_from ?
          <>
            <div className="text-textLight">
              Requested User :
              {request_from?.type === 1
                ? " ADMIN"
                : request_from?.type === 2
                  ? " STAFF MEMBER"
                  : request_from?.type === 3
                    ? " STUDENT"
                    : " Unknown"}
              {" | "}
              {request_from?.email
                ? `${request_from.email} (${request_from.email || "No Email"})`
                : "No Username"}
            </div>
          </>
          : null}
      </div>
    </div>
    <div className="flex flex-col items-end gap-1">
      <DefaultBadge status={1} custom={event} />
      <div>IP Address : {ip || "-"}</div>
    </div>
  </div>
);

export default AuditLog;
